<template>
  <div class="container">
    Aguarde.. carregando tela
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
export default {
  name: "autenticacaoDigital",
  created() {
    let auth = this.$route.query.auth;
    if(!auth){
      this.$router.push({ path: "/login"});
    }else{
      LoginService.loginAuth(auth).then(
        (data) => {
          //You can get warning (error: 'data' is defined but never used;), if you don't use parameters;
          console.log(data);
          const homePage = LoginService.currentUserValue.homePage;
          this.$router.push(homePage);
        },
        (error) => {
          console.log(error);
          this.erro = "Problema ao autenticar com certificado digital!";
          this.$router.push({ path: "/login", params: { erro: '6'}});
        }
      );
    }
  }
};
</script>
<style>
</style>

